<template>
  <div class="offer-campaign-group">
    <div class="offer-campaign-header" @click="collapsed = !collapsed">
      <VdIcon
        store="fas"
        :name="collapsed ? 'chevron-right' : 'chevron-down'"
        custom-size="10px"
        color="var(--vd-color-grey-600, #6b7280)"
      />
      {{ label }} ({{ offers.length }})
    </div>
    <template v-if="!collapsed">
      <span v-for="offer in offers" :key="offer.id">{{ offer.name }}</span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import VdIcon from "@/components/VdIcon/VdIcon.vue";

defineProps<{
  label: string;
  offers: { id: string; name: string }[];
}>();

// Each campaign group manages its own collapse state; collapsed by default.
const collapsed = ref(true);
</script>

<style lang="scss" scoped>
.offer-campaign-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-left: 0.75rem;

  .offer-campaign-header {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: var(--vd-color-grey-600, #6b7280);
    cursor: pointer;
    user-select: none;
  }
}
</style>
